module.exports = __webpack_public_path__ + "img/3tgi-e100-695.prt.bb00234b.jpg";